// [APP-FORK] 앱(웹뷰) 여부 판별 — 런타임 UA 감지.
//   shopadmin-app 도메인은 앱 웹뷰와 실제 웹 상점주가 함께 쓴다. 빌드타임 env(REACT_APP_IS_APP)로는
//   브라우저 접속도 앱으로 오인해 헤더/푸터/좌측메뉴가 사라졌다 → UA 로 런타임 구분한다.
//   근거: 앱 웹뷰가 UA 에 'naegiftApp/1.0' 을 명시 설정한다
//         (naegift_mobile_app/lib/webview/web_view_page.dart:133-137 InAppWebViewSettings.userAgent).
//         Android 는 UA 리터럴에 마커를 직접 포함하고, iOS 는 같은 파일 :91 에서 기본 WKWebView UA
//         끝에 ' naegiftApp/1.0' 을 덧붙인다(커밋 4ab6972). :112-116 이 UA 조회 완료 전엔 웹뷰를
//         만들지 않으므로 마커 없는 로드는 발생하지 않는다.
//   ★iOS UA 에 마커가 없다는 이유로 이 판정을 빌드타임 env 로 바꿨던 커밋(990bc4f)이 있으나,
//     4ab6972 가 iOS 마커를 붙여 그 근거는 소멸했다. env 는 빌드타임 상수라 같은 번들을 앱 웹뷰와
//     웹 상점주가 함께 쓰는 shopadmin-app 도메인에서는 둘을 런타임에 구분할 수 없다 → 되돌리지 말 것.
//   ★window.flutter_inappwebview 마커를 쓰지 않는 이유: 주입 타이밍이 보장되지 않는데
//     아래 :35-37 리시버 등록이 "모듈 평가 시점"에 실행돼, 마커가 아직 없으면 로그아웃 위임이 통째로
//     스킵된다. navigator.userAgent 는 스크립트 실행 시점에 항상 존재 → 타이밍 안전.
export const isApp = () =>
  typeof navigator !== 'undefined' &&
  navigator.userAgent.includes('naegiftApp');

// [APP-FORK] 앱 로그아웃 리시버 등록(앱 빌드에서만 로드) — user 판 isApp.ts:43-45 패턴 동일.
//   isApp.js 는 앱 시작 시 여러 컴포넌트(leftMenu/Header/Footer 등)가 import → 모듈 1회 로드 시
//   리시버를 등록한다(appAuthReceiver 내부 registered 가드로 멱등). 웹(isApp=false)은 미등록 → 웹 영향 0.
if (isApp()) {
  import('./appAuthReceiver').then(m => m.initAppAuthReceiver());
}
